// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gO","h5Button":"gO","button":"gP","block":"gQ","btnDefault":"gR","disable":"gS","btnPrimary":"gT"};